module.exports = __webpack_public_path__ + "static/img/default-product-image.c28ac4b8.svg";